import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { IonLoading, IonImg, IonButton, IonList, IonText } from '@ionic/react';
import { InputField } from 'components/form';
import AppActions from 'redux/AppRedux';
import api_v2 from 'services/api_v2';
import { encryptPhone } from 'utils/phone';
import schema from './schema';

const INITIAL_VALUES = {
  password: '',
  passwordConfirm: '',
  code: '',
};

function ResetPasswordForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const queryParams = new URLSearchParams(useLocation().search);
  const phone = queryParams.get('phone') || ' ';

  const handleSubmit = async (values, actions) => {
    try {
      await api_v2().resetPassword({
        phone: `+1${phone}`,
        password: values.password,
        code: values.code,
      });

      dispatch(
        AppActions.setToast('Your password is reset successfully', 'success')
      );

      history.push(`/auth/login?phone=${phone.replace('+1', '')}`);
    } catch (e) {
      dispatch(
        AppActions.setToast(e.message || 'Password reset failed', 'danger')
      );
    }

    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={INITIAL_VALUES}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting }) => {
        return (
          <Form>
            <IonLoading isOpen={isSubmitting} message="Loading..." />
            <IonList>
              <div className="auth-logo">
                <IonImg src="/assets/vemospay-logo.png" />
              </div>
              <div className="mb-3x">
                <IonText>
                  A text message with your password reset code has been sent to
                  *** *** {encryptPhone(phone)}.
                </IonText>
              </div>
              <Field
                strongLabel
                component={InputField}
                name="code"
                type="tel"
                label="Enter Reset Code"
              />
              <Field
                strongLabel
                component={InputField}
                name="password"
                type="password"
                label="Password"
              />
              <Field
                strongLabel
                component={InputField}
                name="passwordConfirm"
                type="password"
                label="Confirm Password"
              />
              <div className="mb-5x mt-3x text-center">
                <IonButton
                  className="sign-btn"
                  color="tertiary"
                  fill="solid"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Reset Password
                </IonButton>
              </div>
            </IonList>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ResetPasswordForm;
